export default (context, html) => html`
  <aofl-img id="modal-close-button" class="tab-outline-blue enteractive tab-accessibility" role="button" @click="${(e) => context.closeModal(e)}" src="/assets/templates/modal-close-button/popup-close-button-v1.svg" width="48" height="48" alt="Close Popup" tabindex="0"></aofl-img>
`;
